CollectionUtility = {

  objectsMatch: (obj1, obj2) ->
    return false unless obj1 && obj2
    return false unless Object.keys(obj1).length == Object.keys(obj2).length
    for key, value of obj1
      if typeof(value) == "object"
        return CollectionUtility.objectsMatch(value, obj2[key])
      else
        return false unless value == obj2[key]
    for key, value of obj2
      if typeof(value) == "object"
        return CollectionUtility.objectsMatch(value, obj1[key])
      else
        return false unless value == obj1[key]

    return true

  basicDebounce: (fn, timeout) ->
    myTimeout = 0
    args = []
    ctx = null

    callIt = ()->
      fn.apply(ctx, Array.prototype.slice.call(args))

    return ()->
      args = arguments
      ctx = this
      clearTimeout myTimeout
      myTimeout = setTimeout callIt, timeout

}


module.exports = CollectionUtility
